let zhTw = {
  componentModule: "元件清單",
  componentMenu: "元件菜單",
  componentCreationReview: "元件創建與審核",
  paramsManagement: "參數管理",
  manufacturerManagement: "製造商",
  encapsulationTypeManagement: "封裝類型",
  componentMaterial: "材質配置",
  componentParameters: "元件參數",
  systemSettings: "系統設置",
  permissionManagement: "權限管理",
  accountManagement: "賬號管理",
  operationLog: "操作日誌",
  databaseManagement: "數據庫管理",
  version: "版本號",
  systemGuidelines: "系統指引",
  login: "登錄",
  zhmmdl: "賬號密碼登錄",
  xgsjk: "修改數據庫",
  enterUsername: "請輸入用戶名稱",
  enterPass: "請輸入用戶密碼",
  remPass: "記住密碼",
  forgotPass: "忘記密碼",
  xgzhmm: "修改賬號密碼",
  srjmm: "請輸入舊密碼",
  srxmm: "請輸入新密碼",
  qrxmm: "確認新密碼",
  qd: "確定",
  cancel: "取消",
  sslxqh: "搜索類型切換",
  jqss: "精確搜索",
  mhss: "模糊搜索",
  zzsmc: "製造商名稱",
  enterZzs: "請輸入製造商名稱(EN)",
  zzslh: "製造商料號",
  enterzzslh: "請輸入製造商料號",
  zzsfzmc: "製造商封裝名稱",
  enterzzsfzmc: "請輸入製造商封裝名稱",
  cjz: "創建者",
  entercjz: "請輸入創建者名稱",
  createTime: "創建時間",
  startTime: "開始時間",
  endTime: "結束時間",
  reset: "重置",
  search: "查詢",
  searchSet: "搜索配置",
  plsc: "批量刪除",
  dr: "導入",
  dc: "導出",
  zdsz: "字段設置",
  xh: "序號",
  fzlx: "封裝類型",
  fzzlx: "封裝子類型",
  length: "長",
  width: "寬",
  gong: "共",
  tiao: "條",
  everyPage: "每頁",
  go: "前往",
  sszdpz: "搜索字段配置",
  pn: "PN碼",
  yjxx: "元件信息",
  yjc: "元件長",
  yjk: "元件寬",
  yjg: "元件高",
  yjmx: "引腳模型",
  yjsl: "引腳數量",
  yjjj: "引腳間距",
  csmc: "參數名稱",
  csm: "參數名",
  csz: "參數值",
  cszfw: "參數值範圍",
  shz: "審核者",
  shsj: "審核時間",
  drgxyjxx: "導入更新元件信息",
  rz: "日誌",
  xzxydrdsjk: "選擇需要導入的數據庫",
  cslj: "測試連接",
  yshyssffg: "已審核元件是否覆蓋",
  yes: "是",
  no: "否",
  dkbglj: "打開報告路徑",
  dcyjxx: "導出元件信息",
  xzxydcdsjk: "選擇需要導出的數據庫",
  zhmc: "賬號名稱",
  enterZhmc: "請輸入賬號名稱",
  zhqx: "賬號權限",
  xjzh: "新增賬號",
  bjzh: "編輯賬號",
  zt: "狀態",
  fpqx: "分配權限",
  cz: "操作",
  bj: "編輯",
  sc: "刪除",
  yjbjq: "元件編輯器",
  xjandbjzh: "新建&編輯賬號",
  zhmm: "賬號密碼",
  enterZhmm: "請輸入賬號密碼",
  qrmm: "確認密碼",
  enterQrmm: "請再次輸入賬號密碼",
  sfqy: "是否啟用",
  exitVal: "退出登錄",
  all: "全部",
  jscd: "角色菜單",
  cjjs: "創建角色",
  bjjs: "編輯角色",
  qsrjsm: "請輸入角色名",
  qsr: "請輸入",
  jsm: "角色名",
  qxsz: "權限設置",
  qrsctc: "確認刪除",
  qrscjs: "是否確定要刪除，刪除後無法恢復！",
  bm: "所屬部門",
  qsrbm: "請輸入所屬部門",
  qxzfpqx: "請選擇分配權限",
  qxzsfqy: "請選擇是否啟用",
  mmbyz: "兩次密碼不一致",
  isSubmiting: "提交中",
  fzlxmc: "封裝類型名稱",
  enterfzlxmc: "請輸入封裝類型名稱",
  fzzlxbz: "封裝子類型備註",
  enterfzzlxbz: "請輸入封裝子類型備註",
  fzlxbz: "封裝類型備註",
  enterfzlxbz: "請輸入封裝類型備註",
  fzzlxmc: "封裝子類型名稱",
  enterfzzlxmc: "請輸入封裝子類型名稱",
  pleaseEnter: "請輸入",
  add: "新增",
  bz: "備註",
  xzfzlx: "新增封裝類型",
  bjfzlx: "編輯封裝類型",
  fzlxxx: "封裝類型信息",
  qsrzzsmc: "請輸入製造商名稱",
  hbzzs: "合並製造商",
  zzsmc: "製造商名稱",
  bdyjsl: "綁定元件數量",
  gfwz: "官方網站",
  yj: "郵件",
  shzt: "審核狀態",
  sh: "審核",
  dsh: "待審核",
  ysh: "已審核",
  zzsbmxs: "製造商別名顯示",
  zzsbm: "製造商別名",
  zzsxx: "製造商信息",
  zzswz: "製造商網站",
  zzsyj: "製造商郵件",
  sftgzzs: "是否審核通過該製造商?",
  drzzsxx: "導入製造商信息",
  mbxz: "模板下載",
  xzzzsdrmb: "下載製造商導入模板",
  drxx: "導入信息",
  drts: "點擊選擇CSV文件，僅支持.csv格式文件，不超過50MB",
  zzshb: "製造商合並",
  hb: "合並",
  jiang: "將",
  hbjzzs: "合並進製造商",
  qsrzzsmcjxss: "請輸入製造商名稱進行搜索",
  hbfs: "合並方式",
  tszyzzs: "同時轉移製造商",
  jjxqjzy: "僅進行器件轉移",
  jxhb: "進行合並",
  hbjxzts: "合並進行中，請勿關閉系統",
  fzzlxxx: "封裝子類型信息",
  dlrz: "登錄日誌",
  czrz: "操作日誌",
  hyzh: "會員賬號",
  qsrzhcx: "請輸入賬號查詢",
  dlsj: "登錄時間",
  dlzh: "登錄賬號",
  qx: "權限",
  rznr: "日誌內容",
  czsj: "操作時間",
  czlx: "操作類型",
  zh: "賬號",
  plscqr: "請確認是否刪除所選封裝類型，刪除後數據不可恢復",
  plscqr2: "請確認是否刪除所選製造商，刪除後數據不可恢復",
  plscqr3: "請確認是否刪除所選數據庫，刪除後數據不可恢復",
  xgmm: "修改密碼",
  srjmm: "輸入舊密碼",
  srxmm: "輸入新密碼",
  qrxmm: "確認新密碼",
  ts: "提示",
  xgmmcg: "修改密碼成功！",
  zbmhhss: "主別名混合搜索",
  qxz: "請選擇",
  xzzzs: "新增製造商",
  bjzzs: "編輯製造商",
  qsrzzswz: "請輸入製造商網站",
  qsrzzsyj: "請輸入製造商郵件",
  pic: "2D/3D切換",
  kssj: "開始時間",
  jssj: "結束時間",
  jcxx: "基礎信息",
  bjxx: "編輯信息",
  dqxzzd: "當前選擇字段",
  qsrzzsbmen: "請輸入製造商別名(EN)",
  qsrzzsbmcn: "請輸入製造商別名(CN)",
  cx: "撤銷",
  pz: "批准",
  gao: '高',
  bjz: '編輯者',
  bjsj: '編輯時間',
  syzd: '所有字段',
  zdpzts: '使用者自行添加的元件參數，會默認展示在此處',
  enterPn: '請輸入PN碼',
  dryj: '導入元件',
  yxyjdc: '已選元件導出',
  cjsjdc: '創建時間導出',
  cjry: '創建人員',
  xjsjk: "創建數據庫",
  xjyqj: "創建元器件",
  dqsjklb: "當前數據庫列表",


  dlfs: "登錄方式",
  qds: "驅動",
  server: "服務器",
  port: "端口",
  username: "用戶名",
  psw: "密碼",
  database: "數據庫",
  parameter: "參數",
  confirm: "確認",
  edit: "修改",
  testlink: "測試鏈接",

  sjkmc: "數據庫名稱",
  sjkdz: "數據庫地址",
  sjkdk: "數據庫端口",
  sjkzt: "狀態",
  xz: "選擇",
  yzsb: "驗證失敗",
  yztg: "驗證通過",
  dyz: "待驗證",
  qxzdlsjk: "請選擇需要登陸的數據庫",
  xzsjkbtn: "選擇數據庫",
  dqxz: "當前選擇",
  testErrMsg: "請先新建數據庫後再測試鏈接",
  qxzsjk: "請選擇數據庫",
  shtg: "審核通過",
  zm: "主名",
  bm: "別名",
  wjqddc: '文件清單導出',
  qxfpqx: '請先分配權限',
  loading: '加載中...',
  view: "查看",
  sjkbf: '當前數據庫備份',
  gd: '更多',
  fz: '復制',
  cxMPN: '重新關聯MPN',
  szclys: '設置材料和顏色',
  switchtext: '開啓元件參數設置，則創建元件時支持設置元件參數',
  xjyjcs: '新增元件參數',
  bjyjcs: '編輯元件參數',
  cslx: '元件參數類型',
  qxzcslx: '請選擇元件參數類型',
  yjcsm: '元件參數名',
  enterYjcsm: '請輸入元件參數名',
  yjcsdw: '元件參數單位',
  enterYjcsdw: '請輸入元件參數單位',
  lx: '類型',
  dw: '單位',
  czbm: '材質編碼',
  czmc: '材質名稱',
  enterCzbm: '請輸入材質編碼',
  enterCzmc: '請輸入材質名稱',
  elementConfiguration: '元素配置',
  yuansu: '元素',
  tslx: '特殊類型',
  yanse: '顏色',
  yjcz: '元件操作',
  pleaseEnter2: "請輸入",
  qxz2: '請選擇',
  startTime2: "開始時間",
  endTime2: "結束時間",
  xzys: '新增元素',
  ysmc: '元素名稱',
  ysbh: '元素編號',
  enterYsbh: '請選擇元素編號',
  enterYsmc: '請輸入元素名稱',
  bjys: '編輯元素',
  tslxbh: '特殊類型編號',
  enterTslxbh: '請選擇特殊類型編號',
  tslxmc: '特殊類型名稱',
  enterTslxmc: '請輸入特殊類型名稱',
  yanse: '顏色',
  yansebh: '顏色編號',
  yansemc: '顏色名稱',
  enterYansebh: '請選擇顏色編號',
  enterYansemc: '請輸入顏色名稱',
  xztslx: '新增特殊類型',
  bjtslx: '編輯特殊類型',
  xzyanse: '新增顏色',
  bjyanse: '編輯顏色',
  zdyyjcskg: '自定義元件參數開關',
  ycjyjcs: '已創建元件參數',
  ysczzh: '元素材質組合',
  czbm: '材質編碼',
  czmc: '材質名稱',
  xzyjcz: '新增元件材質',
  bjyjcz: '編輯元件材質',
  czlx: '材質類型',
  mc: '名稱',
  hj: '合金',
  tc: '塗層',
  yssl: '元素數量',
  xzyssl: '請選擇元素數量',
  dyzys: '第一種元素',
  derzys: '第二種元素',
  qxzys: '請選擇元素',
  xzxsys: '選擇顯示顏色',
  baocun: '保存',
  qxzyanse: '請選擇顏色',
  qxzlx: '請選擇類型',
  assignMaterials: '分配材質',
  wsyczlb: '未使用材質列表',
  ysyczlb: '已使用材質列表',
  yzbt: '用作本體',
  yzyj: '用作引腳',
  tszy: '同時作用',
  yc: '移除',
  czlb: '材質列表',
  btczlb: '本體材質列表',
  yjczlb: '引腳材質列表',
  bh: '編號',
  gx: '更新',
  ysczzhycz: '此元素材質組合編號已存在',
  xinjian: '新建',
  zhantie: '粘貼',
  szczhys: '設置材質和顏色',
  bjmpnhmfg: '編輯MPN和MFG',
  sjklx: '數據庫類型',
  jzzsmc: '舊制造商名稱',
  xzzsmc: '新制造商名稱',
  jzzslh: '舊制造商料號',
  xzzslh: '新制造商料號',
  enterXzzsmc: '請選擇新制造商名稱',
  enterXzzslh: '請輸入新制造商料號',
  xuanzhuan: '旋轉',
  sjzs: '數據展示',
  liebiao: '列表',
  cssj: '參數數據',
  benti: '本體',
  xingzhuang: '形狀',
  ysfx: '延伸方向',
  yinjiao: '引腳',
  yjmc: '引腳名稱',
  jxyj: '極性元件',
  weizhi: '位置',
  zjz: '中間值',
  zpc: '正偏差',
  fpc: '負偏差',
  zdz: '最大值',
  zxz: '最小值',
  jztx: '加載圖形',
  clgj: '測量工具',
  jzdt: '加載底圖',
  jzpdf: '加載PDF',
  gbpdf: '關閉PDF',
  yjshlc: '元件審核流程',
  bzms: '標註模式',
  zzms: '公差模式',
  psyj: '評審意見',
  tuichu: '退出',
  syg: '上一個',
  xyg: '下一個',
  pldrsn: '批量導入PN',
  xzsndrmb: '下載PN導入模板',
  drsb: '導入異常',
  drsbqd: '導入失敗清單',
  xzcwbg: '下載錯誤報告',
  xzbg: '下載報告',
  gaodu: '高度',
  step1: '基本資訊確認',
  tip1: '已上傳底圖及PDF手冊',
  tip2: '製造商名稱、製造商料號、製造商封裝名稱與手冊一致',
  tip3: '封裝類型、封裝子類型選擇正確',
  tip4: '本體材質、引腳材質、器件參數與手冊一致',
  step2: '極性資訊確認',
  tip5: '極性元件選擇正確',
  tip6: '極性位置放置正確',
  step3: '本體資訊確認',
  tip7: '本體形狀、抬升高度正確',
  tip8: '本體尺寸正確',
  step4: '引腳資訊確認',
  tip9: '引腳模型及形狀正確',
  tip10: '引腳位置、方向正確',
  step5: '確認其餘參數是否正確',
  tip11: '引腳名稱正確',
  kai: '開',
  guan: '關',
  enterBz: '請輸入備註',
  plppyj: '批量匹配元件',
  xzdrmb: '下載導入模板',
  ppyqjsfzkz: '匹配元器件是否在庫中存在',
  ppcg: '匹配成功',
  ppsb: '匹配失敗',
  ppl: '匹配率',
  ppsbqd: '匹配失敗清單',
  ppyc: '匹配異常',
  drcg: '導入成功',
  drsbai: '導入失敗',
  kshbzzs: '開始進行製造商合井',
  dhbyjsl: '待合並元件數量',
  hbyc: '合並失敗',
  hbcg: '合並成功',
  cwrz: '錯誤日誌',
  qxzzzs: '請選擇製造商名稱',
  zzslhlb: '製造商料號列表',
  lhtpf: '是否共享封裝圖形',
  gllh: '關聯料號',
  czcg: '操作成功',
  qxzydcdx: '請選擇要導出的元件',
  zdzxzms: '极值模式',
  hbcgyjsl: '合並成功元件數量',
  dcz: '導出中...',
  ksjxdc: '開始進行導出...',
  dcyjsl: '導出元件數量',
  dcwc: '導出完成',
  dcsb: '導出失敗',
  ksjxdr: '開始進行導入...',
  drwc: '導入完成',
  drsbai: '導入失敗',
  page: '頁',
  clgl: '材料管理',
  bccg: '保存成功',
  shtgl: '審核通過',
  shwtgl: '審核未通過',
  dcmy: '沒有符合的導出內容',
  juxing: '矩形',
  yuanxing: '圓形',
  duobianxing: '多邊形',
  zhijing: '直徑',
  plexe: '批量刷新',
  plsxQxz: '請選擇元件',
  plsxfzlxyjmx: '批量刷新封裝類型和引腳模型',
  dccg: '導出成功',
  hengxiang: '橫向',
  zongxiang: '縱向',
  sflx: '是否類型',
  ryzfclx: '任意字符串類型',
  rqlx: '日期類型',
  zslx: '整數類型',
  zdylx: '自定義類型',
  quanxuan: '全選',
  enterZzslhlb: '請輸入制造商料號列表',
  jbxx: '基本信息',
  zhi: '值',
  tbyjcs: '同步元件參數',
  refresh: '刷新',
  bzsc: '幫助手冊',
  zzs: ' 製造商',
  yjcs: '元件參數',
  btcl: '本體材料',
  yjcl: '引腳材料',
  yqwq: '有鉛/無鉛',
  ESDdj: 'ESD等級',
  zl: '重量',
  smdj: '濕敏等級',
  bzjd: '包裝角度',
  bzpitch: '包裝pitch',
  bzfs: '包裝方式',
  gl: '功率',
  RoHShbyq: 'RoHS環保要求',
  wd: '溫度',
  xzcs: '新增參數',
  dcyjcs: '導出元件參數',
  pldrcs: '批量導入參數',
  wx: '外形',
  yinj: '引腳',
  cs: '參數',
  cjxz: '創建/審核',
  fg: '覆蓋',
  zj: '追加',
  overwriteDialogMessage: '參數存在重複，請確認是否覆蓋？',
  bjyqj: '編輯元器件',
  drjg: '導入結果',
  enterYjzdycs: '請輸入元件自定義參數',
  yjzdycs: '元件自定義參數',
  qxzsj: '請選擇時間',
  tsgd: '抬升高度',
  cd: '長度',
  kd: '寬度',
  jx: '極性',
  qxcl: '清除測量',
  spwtgbsp: '審核未通過元器件不允許撤銷或批准',
  fzzzs: '復制制造商',
  dycg: '調用成功',
  fzyj: '復製元器件'
};

export default zhTw;
